import { render, staticRenderFns } from "./b42.vue?vue&type=template&id=56a80ceb&scoped=true&"
import script from "./b42.vue?vue&type=script&lang=js&"
export * from "./b42.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a80ceb",
  null
  
)

export default component.exports